import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopCommissions from './';

export const getShopCommissionWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: ShopCommissions,
});
